import { render } from "./BottomBtn.vue?vue&type=template&id=0159cb3b&scoped=true"
import script from "./BottomBtn.vue?vue&type=script&lang=js"
export * from "./BottomBtn.vue?vue&type=script&lang=js"

import "./BottomBtn.vue?vue&type=style&index=0&id=0159cb3b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0159cb3b"]])

export default __exports__